import { PluginObject } from 'vue';
import deanIcon from '@/components/deanComponents/deanIcon.vue';
import { mailIcon } from '@deanone/dean-components';

export const OvToastPlugin: PluginObject<any> = {
  install(Vue, option) {

    Vue.component('dean-icon', deanIcon);

    Vue.prototype.$toast = function(notification: {
      text: string,
      theme: 'default' | 'primary' | 'secondary' | 'danger' | 'warning' | 'success' | 'info',
      title?: string,
      icon?: any,
    }) {
      const icon = notification.icon ? notification.icon : mailIcon;

      const vNodesTitle = this.$createElement(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          this.$createElement('dean-icon', {
            props: {
              className: 'toast-icon',
              glyph: icon,
            },
            attrs: {
              height: 13,
            },
          }),
          this.$createElement('strong', {
              class: 'mr-2',
            },
            notification.title ? notification.title : notification.theme,
          ),
        ],
      );

      this.$root.$bvToast.toast(notification.text, {
        title: [vNodesTitle],
        toaster: 'ov-toaster',
        variant: notification.theme,
        appendToast: true,
        // noAutoHide: true, // debug
      });
    };
  },
};
